import { useToast } from "@/components/ui/toastercustom";
import CONFIGS from "@/constants/env";
import { ERROR_MESSAGES_LOGIN } from "@/constants/messages";
import {
  IConnectSocial,
  ILoginWithProvider,
} from "@/features/authentication/interfaces/IAuth";
import { loginWithProvider } from "@/features/authentication/services/auth.services";
import useProfileStore from "@/stores/profile";
import { onSetCookie } from "@/utils/handleCookie";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useState } from "react";

const useLoginWithProvider = () => {
  const { toast } = useToast();

  // Router
  const router = useRouter();

  // Store
  const { setToken, setProfile, setRefreshToken } = useProfileStore();
  // State
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isConnectAcount, setIsConnectAcount] = useState<string | null>(null);

  // USE MUTATION ---------------------------------------------------------
  const { mutate: mutateLoginWithProvider } = useMutation({
    mutationKey: ["loginWithProvider"],
    mutationFn: async (data: ILoginWithProvider) => {
      const result = await loginWithProvider(data);
      if (result && result.status) {
        // After successful login, display toast
        toast({
          title: "Success",
          type: "success",
          text: "Login successful",
        });

        // Save data to local storage using Zustand
        // TODO: BE should return app data user
        setProfile(result.data);
        setToken(result.token);
        setRefreshToken(result.refresh_token);
        onSetCookie({
          token: result.token,
          refresh_token: result.refresh_token,
          created_from: result.data.created_from,
        });
        // Redirect to home
        if (isConnectAcount === "connect_account") {
          return router.push("/settings/account-setting/connected-account");
        }
        return router.push("/my-agents");

        // Next need to manage token
      } else {
        // When status is false
        toast({
          title: "Login Failed",
          type: "error",
          text: result?.message || ERROR_MESSAGES_LOGIN,
        });
      }
    },
    onSuccess: () => {
      setIsDisabled(false);
    },
    onError: () => {
      setIsDisabled(false);
      toast({
        title: "Login Failed",
        type: "error",
        text: ERROR_MESSAGES_LOGIN,
      });
    },
  });
  // -----------------------------------------------------------------------

  const signInWithDiscord = ({
    url,
    route,
  }: {
    url: string;
    route: IConnectSocial;
  }) => {
    const redirectUri = `${url}/api/auth/callback/${route}`;
    const discordAuthUrl =
      "https://discord.com/oauth2/authorize?" +
      `client_id=${CONFIGS.DISCORD_CLIENT_ID}` +
      "&response_type=code" +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      "&scope=email+identify";

    window.location.href = discordAuthUrl;
  };
  return {
    mutateLoginWithProvider,
    isDisabled,
    signInWithDiscord,
    setIsConnectAcount,
    isConnectAcount,
  };
};

export default useLoginWithProvider;
